<app-header></app-header>


<!-- ======= Hero Section ======= -->
<section id="hero" class="hero_slide">
    <div data-bs-interval="5000" class="" data-bs-ride="carousel">
        <!-- Slide 1 -->
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-6 mt-5 cust-slider-left-text pad_top_30">
                    <h2 class="animate__animated animate__fadeInDown text-alignment-center">Predictive Maintenance<br />
                        System</h2>
                    <p class="animate__animated animate__fadeInUp width-100 m-0 text-alignment-center">Reduce assests
                        downtime by using AI powered
                        insights of data gathered from IOT Sensor.</p>
                    <div class="flex_center pad-top-25">
                        <a href="https://www.samyak.com/contact-us/"
                            class="btn-get-started animate__animated animate__fadeInUp scrollto margin-top-25 cursor_pointer">Contact
                            Us</a>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 text-right">
                    <img src="assets/img/predictive_img1.svg" class="slider-img-level slider-img">
                </div>
            </div>


        </div>
    </div>
</section><!-- End Hero -->

<main id="main">
    <section id="clients" class="clients">
        <div class="container p-0">
            <div class="row client-logo-main">
                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/Adani-power-logo.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/Cognitive Technologies.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/Anodyne Technologies.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/Energy Doctor (Tricolite Energy Soln).svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/Navi mumbai corporation.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/rech.svg" class="img-fluid" alt="">
                </div>

            </div>

        </div>
    </section>

    <section id="services" class="services">
        <div class="container aos-init aos-animate" data-aos="fade-up">

            <div class="section-title">

                <p class="pt-4 pb-4">What are the challenges do manufacturer face?</p>

            </div>



            <div class="align-items-center text-center justify-content-center">
                <img src="assets/img/Predictive-Maintenance-System_GIF.gif" alt="">
            </div>

        </div>
    </section>



    <section id="cta" class="cta space-comman">

        <div class="container aos-init aos-animate" data-aos="zoom-in">
            <div class="row display_two_column">
                <div class="first_column_image pb-3">
                    <img src="assets/img/iiot_img1.svg">
                </div>
                <div class="second_column_text">
                    <div class="second_column_image">
                        <h3 class="text-left">What is predictive maintenance?</h3>
                        <p class="mt-30 text_jus">Predictive maintenance is a technique that uses data analysis tools
                            and techniques to detect anomalies in your operation and possible defects in equipment and
                            processes so you can fix them before they result in failure.

                        </p>
                        <p class="mt-30 text_jus">
                            Ideally, predictive maintenance allows the maintenance frequency to be as low as possible to
                            prevent unplanned reactive maintenance, without incurring costs associated with doing too
                            much preventive maintenance.</p>

                    </div>
                </div>
            </div>
        </div>
    </section>


    <section id="Advanced Energy" class="services">
        <div class="container aos-init aos-animate" data-aos="fade-up">
            <div class="row display_two_column-1">
                <div class="second_column_text">
                    <div class="second_column_image pad_27">
                        <div class="section-title Energy-Analytics-title" style="padding-top: 20px;">

                            <p class="text-left pad-top-desk">The impact of predictive maintenance</p>

                        </div>
                        <p class="overview list_item">Predictive maintenance seeks to define the best time to do work on an
                            asset so maintenance frequency is as low as possible and reliability is as high as possible
                            without unnecessary costs.



                            <br /><br />

                            Utilizing the Internet of Things is key for implementing a successful predictive maintenance
                            program, as is the use of predictive maintenance sensors and techniques, such as vibration
                            analysis, oil analysis, thermal imaging, and equipment observation.
                        </p>
                    </div>
                </div>
                <div class="first_column_image pb-3">
                    <div class="align-items-center text-center justify-content-center pad_27">

                        <img class="embed-responsive-item" src="assets/img/predictive_maintainance_brief.svg">

                    </div>
                </div>
            </div>
        </div>
    </section>


    <section id="How-Rms-Works" class="services gray-container space-comman padding-bottom-50 margin-bottom-0">
        <div class="container aos-init aos-animate" data-aos="fade-up">

            <div class="section-title">

                <p class="pt-4">Primary components of our Predictive Maintenance</p>

            </div>


            <div class="row pad_15">

                <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init">
                    <div class="icon-box height-300 w_100">
                        <div class="icon-container pb-3"><img src="assets/img/energy.svg" class="icon_img_mobile"></div>
                        <h4><a href="">Sensor network for Data Collection</a></h4>
                        <p class="text_jus" style="margin-bottom: 0px !important;">We can connect Samyak's 4g GSM device
                            with water meters' and it will send meter readings to cloud. </p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
                    <div class="icon-box height-300 w_100">
                        <div class="icon-container pb-3"><img src="assets/img/configuration.svg"
                                class="icon_img_mobile"></div>
                        <h4><a href="">IoT Gateway hardware and software</a></h4>
                        <p class="text_jus" style="margin-bottom: 0px !important;">We can connect Samyak's 4g GSM device
                            with water meters' and it will send meter readings to cloud. </p>
                    </div>
                </div>


                <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
                    <div class="icon-box height-300 w_100">
                        <div class="icon-container pb-3"><img src="assets/img/graph.svg" class="icon_img_mobile"></div>
                        <h4><a href="">Machine Learning for Predictive Analysis</a></h4>
                        <p class="text_jus" style="margin-bottom: 0px !important;">Monitor and track water flowing
                            through treatment plants. Also RMS can help in capturing pH, BOD, oxygen and many other </p>
                    </div>
                </div>



            </div>
        </div>
    </section>


    <section id="services" class="services">
        <div class="container aos-init aos-animate" data-aos="fade-up">

            <div class="section-title">

                <p class="pt-4">Benefits of Predictive Maintenance </p>

            </div>



            <div class="align-items-center text-center justify-content-center mt-30">
                <img src="assets/img/iiot_software_gif2.gif" class="img-fluid" alt="">
            </div>

        </div>
    </section>


    <section id="testimonials" class="testimonials section-bg services mt-30">
        <div class="container aos-init aos-animate" data-aos="fade-up">

            <div class="section-title">

                <p class="pt-4 pad_15">Operational Overview & Advance Analytics</p>

            </div>



            <div class="best_service">
                <owl-carousel [options]="SlideOptions1" [carouselClasses]="['owl-theme', 'sliding']">
                    <div class="item" *ngFor="let img of Images1">
                        <div style="align-content: center">
                            <div class="icon-box icon-box2 icon-box3">
                                <div class="icon-container"><img src="{{img.img}}"></div>
                                <h4><a href="">{{img.title}}</a></h4>


                            </div>
                        </div>
                    </div>
                </owl-carousel>
            </div>
        </div>
    </section>


    <section id="testimonials" class="industries testimonials section-bg services">
        <div class="container aos-init aos-animate" data-aos="fade-up">

            <div class="section-title">

                <p class="pt-3" style="color: #fff;">Industries We Serve</p>

            </div>

            <div class="best_service">
                <owl-carousel [options]="SlideOptions2" [carouselClasses]="['owl-theme', 'sliding']">
                    <div class="item" *ngFor="let img of Images2">
                        <div class="">
                            <div class="icon-container34">
                                <p><img class="indus-img" src="{{img.img}}"></p>
                                <div class="h3">{{img.title}}</div>
                            </div>
                        </div>
                    </div>
                </owl-carousel>
            </div>

        </div>
    </section>


    <section id="testimonial-area" class="pt-5 padding-bottom-new">

        <div class="container">
            <div class="mx-auto">
                <header class="section-header text-center">
  
                    <h2  class="m_top">What our Customers are Saying</h2>
                </header>
            </div>
            <div class="testimonial-block" style="padding-bottom: 40px; padding-top: 45px;">
                <div style="width: 428px;" class="image_display"><img src="assets/img/user5.svg" alt=""
                        class="testimonial_img"></div>
  
                <div class="padding-both-side">
  
                    <h1> <span><img src="../../assets/img/comma.svg" class="commam"></span></h1>
                    <p class="text_align_center" style="font-size: 14px;">“Samyak's support is really good and we are
                        very happy with the services they have provided to us like hardware data integration through GSM
                        gateways. Two way communication is helping us a big time. We heartily appreciate all kind of
                        support.”</p>
                    <div class="testimonial">
                        <p class="testimonialFrom text_align_center" style="font-size: 14px;">Jummal Popis</p>
                        <p class="text_align_center" style="font-size: 14px;">Founder Circle</p>
                    </div>
                </div>
            </div>
  
  
  
        </div>
  
    </section>
  


    <app-latest-article></app-latest-article>

    <app-footer></app-footer>
</main>